"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TriptychCard = void 0;

var _react = _interopRequireDefault(require("react"));

var _Box = require("../../Box");

var _Flex = require("../../Flex");

var _Image = require("../../Image");

var _Text = require("../../Text");

var _CardTag = require("../CardTag");

var _TriptychCard = require("./TriptychCard");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TriptychCard = function TriptychCard(_ref) {
  var images = _ref.images,
      title = _ref.title,
      subtitle = _ref.subtitle,
      status = _ref.status,
      rest = _objectWithoutProperties(_ref, ["images", "title", "subtitle", "status"]);

  var imageAttributes = (0, _TriptychCard.isArrayOfStrings)(images) ? images.map(function (src) {
    return {
      src: src
    };
  }) : images;
  return /*#__PURE__*/_react.default.createElement(_Box.Box, _extends({
    width: "100%",
    position: "relative"
  }, rest), /*#__PURE__*/_react.default.createElement(_Box.Box, {
    width: "100%",
    height: "0",
    pt: "67%",
    position: "relative"
  }, /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    flexDirection: "row",
    width: "100%",
    height: "100%",
    position: "absolute",
    top: "0",
    borderRadius: "4px",
    overflow: "hidden"
  }, /*#__PURE__*/_react.default.createElement(_Box.Box, {
    backgroundColor: "black10",
    width: "67%",
    overflow: "hidden",
    mr: "1px"
  }, /*#__PURE__*/_react.default.createElement(_Image.Image, _extends({
    alt: "",
    height: "100%",
    width: "100%"
  }, imageAttributes[0]))), /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    width: "33%",
    flexDirection: "column"
  }, images.length < 2 && /*#__PURE__*/_react.default.createElement(_Box.Box, {
    backgroundColor: "black10",
    height: "100%",
    width: "100%",
    ml: "1px"
  }), images[1] && /*#__PURE__*/_react.default.createElement(_Box.Box, {
    backgroundColor: "black10",
    height: images[2] ? "50%" : "100%",
    overflow: "hidden",
    ml: "1px",
    mb: images[2] ? "1px" : "0"
  }, /*#__PURE__*/_react.default.createElement(_Image.Image, _extends({
    alt: "",
    height: "100%",
    width: images[2] ? "100%" : "auto"
  }, imageAttributes[1]))), images[2] && /*#__PURE__*/_react.default.createElement(_Box.Box, {
    backgroundColor: "black10",
    height: "50%",
    overflow: "hidden",
    ml: "1px",
    mt: "1px"
  }, /*#__PURE__*/_react.default.createElement(_Image.Image, _extends({
    alt: "",
    height: "100%",
    width: "100%"
  }, imageAttributes[2])))))), /*#__PURE__*/_react.default.createElement(_Text.Text, {
    mt: 1,
    variant: "mediumText"
  }, title), subtitle && /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "text",
    color: "black60"
  }, subtitle), status && /*#__PURE__*/_react.default.createElement(_CardTag.CardTag, {
    position: "absolute",
    top: 1,
    left: 1
  }, status));
};

exports.TriptychCard = TriptychCard;
TriptychCard.displayName = "TriptychCard";
//# sourceMappingURL=v2.js.map